// chart ids
export const CHART = {
  price: "price",
  volume: "volume",
};
